import type { TranslationMessages } from '../types';

export const ingredients: TranslationMessages = {
  name: 'Ingredient Management',
  add: 'Add Ingredient',
  edit: 'Edit Ingredient',
  create: 'Create Ingredient',
  list: 'Ingredients',
  search: 'Search ingredients...',
  empty: 'No ingredients found',
  delete: {
    title: 'Delete Ingredient',
    confirm:
      'Are you sure you want to delete this ingredient? This action cannot be undone.',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    imageId: 'Image',
    recipeId: 'Recipe (Optional)',
    recipe: 'Recipe',
  },
  recipe: {
    none: 'No recipe',
    hasRecipe: 'Has recipe',
    help: 'If this ingredient is made from other ingredients, select a recipe. This allows nested recipes up to 2 levels.',
  },
  placeholders: {
    selectRecipe: 'Select recipe',
    searchRecipe: 'Search recipes...',
  },
};
